import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { LOGIN_PAGE } from '../utils/authConfig';
import { Box, Spinner, Center } from '@chakra-ui/react';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    const checkAuth = () => {
      const loggedIn = localStorage.getItem('isLoggedIn') === 'true';
      const accessToken = localStorage.getItem('access_token');
      const userProfile = localStorage.getItem('user_profile');
      
      // Clear invalid auth data
      if (!loggedIn || !accessToken || !userProfile) {
        localStorage.clear();
        setIsAuthenticated(false);
        return;
      }

      try {
        const profile = JSON.parse(userProfile);
        // Verify the profile has required fields
        if (!profile.googleId || !profile.email) {
          localStorage.clear();
          setIsAuthenticated(false);
          return;
        }
        setIsAuthenticated(true);
      } catch (error) {
        localStorage.clear();
        setIsAuthenticated(false);
      }
    };

    checkAuth();
    
    // Only listen for storage events that affect auth state
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'isLoggedIn' || e.key === 'access_token' || 
          e.key === 'user_profile' || e.key === null) {
        checkAuth();
      }
    };
    
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  // Show loading state while checking authentication
  if (isAuthenticated === null) {
    return (
      <Center h="100vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to={LOGIN_PAGE} state={{ from: location }} replace />;
  }

  return <>{children}</>;
}; 